import React from 'react';
import { Link as v4Link } from 'react-router-dom';
import { connect } from 'react-redux';
import cx from 'classnames';
import PropTypes from 'prop-types';

// Multibrand-UI Components
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import Text from '@zg-rentals/multibrand-ui/lib/Text';

import PropertiesConstants from 'app/shared/constants/PropertiesConstants';

import PropertiesViewGrid from 'app/shared/components/properties/PropertiesViewGrid';
import PropertiesViewList from 'app/shared/components/properties/PropertiesViewList';

import ModalActions from 'app/shared/actions/ModalActions';

// Selectors
import { AppSelectors, UserSelectors } from 'app/shared/selectors';

import pathsManifest from 'app/shared/pathsManifest';

// Stylesheets
import './style.scss';

const propTypes = {
    displayTimedOutMessage: PropTypes.bool.isRequired,
    listings: PropTypes.array.isRequired,
    displayNoListingsFoundMessage: PropTypes.bool.isRequired,
    viewType: PropTypes.string,
};

const defaultProps = {
    viewType: PropertiesConstants.PROPERTIES_VIEW_TYPE.GRID,
};

const PropertiesDisplay = ({
    listings,
    user,
    isSOH,
    dispatch,
    showArchived,
    displayNoListingsFoundMessage,
    displayTimedOutMessage,
    didPropertiesLoad,
    viewType,
}) => {
    const showPropModal = (e) => {
        e.preventDefault();
        dispatch(ModalActions.updateDisplayAddPropertyModal({ isOpen: true }));
    };

    const renderTimedOutDisplay = () => (
        <div className="PropertiesDisplay-no-listings-CTA">
            <Text>
                We are having trouble retrieving your properties at this time.
                Please refresh the page or check back soon.
            </Text>
        </div>
    );

    const renderNoListingsFound = () => {
        const paths = pathsManifest.getAllPaths();

        if (showArchived) {
            return <Text>You don’t have any archived properties</Text>;
        }

        if (user.features.canAddListing) {
            return (
                <Text>
                    No listings found. Would you like to
                    {' '}
                    <Link
                        reactRouterLink={v4Link}
                        to={paths.propertiesPage}
                        onClick={showPropModal}
                    >
                        post a listing
                    </Link>
                    ?
                </Text>
            );
        }

        return <Text>No listings found.</Text>;
    };

    const renderView = () => (viewType === PropertiesConstants.PROPERTIES_VIEW_TYPE.GRID ?
        <PropertiesViewGrid listings={listings} /> :
        <PropertiesViewList listings={listings} />
    );

    const renderListingsDisplay = () => (
        <React.Fragment>
            {listings.length > 0 ?
                renderView() :
                (
                    <div className="PropertiesDisplay-no-listings-CTA">
                        {displayNoListingsFoundMessage && renderNoListingsFound()}
                    </div>
                )}
        </React.Fragment>
    );

    const classNames = cx('PropertiesDisplay', {
        SOH: isSOH,
    });

    return (
        <div className={classNames}>
            {displayTimedOutMessage || !didPropertiesLoad ? renderTimedOutDisplay() : renderListingsDisplay()}
        </div>
    );
};

PropertiesDisplay.propTypes = propTypes;
PropertiesDisplay.defaultProps = defaultProps;

const mapStateToProps = state => ({
    user: UserSelectors.makeUser(state),
    cookieEnabledServices: AppSelectors.makeCookieEnabledServices(state),
    isSOH: AppSelectors.makeIsSOH(state),
});

export { PropertiesDisplay };
export default connect(mapStateToProps)(PropertiesDisplay);
